import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import { Toaster } from 'react-hot-toast';

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  const applyCustomTheme = (customColors) => {
    if (!customColors) return;
    const root = document.documentElement;
    if (customColors.bgPrimary) root.style.setProperty('--bg-primary', customColors.bgPrimary);
    if (customColors.bgSecondary) root.style.setProperty('--bg-secondary', customColors.bgSecondary);
    if (customColors.bgTertiary) root.style.setProperty('--bg-tertiary', customColors.bgTertiary);
    if (customColors.blurple) {
      root.style.setProperty('--blurple', customColors.blurple);
      root.style.setProperty('--blurple-hover', customColors.blurple);
    }
    if (customColors.textNormal) root.style.setProperty('--text-normal', customColors.textNormal);
    if (customColors.textMuted) root.style.setProperty('--text-muted', customColors.textMuted);
  };

  const clearCustomTheme = () => {
    const root = document.documentElement;
    root.style.removeProperty('--bg-primary');
    root.style.removeProperty('--bg-secondary');
    root.style.removeProperty('--bg-tertiary');
    root.style.removeProperty('--blurple');
    root.style.removeProperty('--blurple-hover');
    root.style.removeProperty('--text-normal');
    root.style.removeProperty('--text-muted');
  };

  const applyTheme = (themeName, customColors) => {
    document.body.className = `theme-${themeName}`;
    if (themeName === 'custom' && customColors) {
      applyCustomTheme(customColors);
    } else {
      clearCustomTheme();
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem('qsniper_user');
    const storedToken = localStorage.getItem('qsniper_token');
    if (storedUser && storedToken) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);
      setToken(storedToken);
      applyTheme(parsedUser.theme || 'dark', parsedUser.custom_theme);
    }
  }, []);

  const handleLogin = (userData, userToken) => {
    setUser(userData);
    setToken(userToken);
    applyTheme(userData.theme || 'dark', userData.custom_theme);
    localStorage.setItem('qsniper_user', JSON.stringify(userData));
    localStorage.setItem('qsniper_token', userToken);
  };

  const handleLogout = () => {
    setUser(null);
    setToken(null);
    applyTheme('dark', null);
    localStorage.removeItem('qsniper_user');
    localStorage.removeItem('qsniper_token');
  };

  const handleThemeChange = (newTheme, customColors = null) => {
    const updatedUser = { ...user, theme: newTheme, custom_theme: customColors || user.custom_theme };
    setUser(updatedUser);
    applyTheme(newTheme, updatedUser.custom_theme);
    localStorage.setItem('qsniper_user', JSON.stringify(updatedUser));
  };

  return (
    <div className="app-container">
      <Toaster position="bottom-right" toastOptions={{
        style: {
          background: 'var(--bg-floating)',
          color: 'var(--text-normal)',
          borderRadius: '8px',
          border: '1px solid var(--border-subtle)',
          fontSize: '14px',
        }
      }}/>
      {!token ? (
        <Login onLogin={handleLogin} />
      ) : (
        <Dashboard user={user} token={token} onLogout={handleLogout} onThemeChange={handleThemeChange} />
      )}
    </div>
  );
}

export default App;
